// Copyright (c) 2018 Deere & Company

import ExcelLayoutColumn from '@deere/cps-it.warranty-model-factory/lib/excel-layout-column';
import _ from 'lodash';
import {getClaimsColumns} from '../../claim/shared/services/claims-excel-columns';
import {getPartRequestsColumns} from '../../part-requests/shared/services/part-requests-excel-columns';
import {getPipProductColumns} from '../../pip/shared/services/pip-product-excel-columns';
import {getPipProductSearchColumns} from '../../pip/pip-search/services/pip-product-search-excel-columns';
import {getPipSearchColumns} from '../../pip/pip-search/services/pip-search-excel-columns';
import {getProductSearchColumns} from '../../product/search/services/excel-columns';
import {getRegistrationReviewColumns} from '../../product/registration-review/services/excel-columns';
import {getTransfersColumns} from '../../product/transfers/services/excel-columns';

const availableColumns = {
    claims: getClaimsColumns,
    partRequests: getPartRequestsColumns,
    pipProductSearch: getPipProductSearchColumns,
    pipProducts: getPipProductColumns,
    pipSearch: getPipSearchColumns,
    productSearch: getProductSearchColumns,
    registrations: getRegistrationReviewColumns,
    transfers: getTransfersColumns
};

export const getAllAvailableColumns = listId =>
    availableColumns[listId]().listColumns.map(column =>
        new ExcelLayoutColumn({
            id: column.id
        })
    );

export const getAvailableColumns = (listId, selectedColumns) => {

    const listColumns = availableColumns[listId]().listColumns.map(column =>
        new ExcelLayoutColumn({
            id: column.id
        })
    );

    return _.difference(listColumns, selectedColumns);

};



// WEBPACK FOOTER //
// ./src/shared/services/available-excel-columns.js